import { ethers } from "ethers";
import {
  EMETH_CORE_CONTRACT_ADDRESS,
  EMETH_PROXY_CONTRACT_ADDRESS,
} from "../constants";
import EMETH_CORE_ABI from "../constants/abi/emethCore.json";
import EMETH_PROXY_ABI from "../constants/abi/emethProxy.json";

export const getBalanceOf = async (
  contractAddress: string | undefined,
  address: string | null,
  abi: any,
  provider: any
) => {
  if (!contractAddress || !address) {
    return "";
  }
  const contract = new ethers.Contract(contractAddress, abi, provider);

  let balances: any = null;
  try {
    balances = await contract["balanceOf"](address);
    return ethers.formatUnits(balances, 0) || balances;
  } catch (error) {
    if ((error as any).data === "0x") {
      return "0";
    }
    const message = (error as any).message || (error as any).reason;
    return `ERROR: ${message}`;
  }
};

export const getCurrentSlot = async (provider: any) => {
  if (!EMETH_CORE_CONTRACT_ADDRESS) {
    return "";
  }
  const contract = new ethers.Contract(
    EMETH_CORE_CONTRACT_ADDRESS,
    EMETH_CORE_ABI,
    provider
  );

  let currentSlot: any = null;
  try {
    currentSlot = await contract["currentSlot"]();
    return ethers.formatUnits(currentSlot, 0) || currentSlot;
  } catch (error) {
    // const message = (error as any).message || (error as any).reason;
    return "";
  }
};

export const getMinTarget = async (programId: number, provider: any) => {
  if (!EMETH_CORE_CONTRACT_ADDRESS || !programId) {
    return "";
  }
  const contract = new ethers.Contract(
    EMETH_CORE_CONTRACT_ADDRESS,
    EMETH_CORE_ABI,
    provider
  );

  let data: any = null;
  try {
    data = await contract["programs"](programId);
    return ethers.formatUnits(data.minTarget, 0) || data.minTarget;
  } catch (error) {
    const message = (error as any).message || (error as any).reason;
    return `ERROR: ${message}`;
  }
};

export const getDeposits = async (address: string, provider: any) => {
  if (!EMETH_PROXY_CONTRACT_ADDRESS || !address) {
    return "";
  }
  const contract = new ethers.Contract(
    EMETH_PROXY_CONTRACT_ADDRESS,
    EMETH_PROXY_ABI,
    provider
  );

  let data: any = null;
  try {
    data = await contract["deposits"](address);
    return ethers.formatUnits(data, 0);
  } catch (error) {
    const message = (error as any).message || (error as any).reason;
    return `ERROR: ${message}`;
  }
};

export const onDeposit = async (matic: string) => {
  const amountValue = parseFloat(matic) * Math.pow(10, 18);
  try {
    const iface = new ethers.Interface(EMETH_PROXY_ABI);
    const ethereum = (window as any).ethereum;

    const data = iface.encodeFunctionData("deposit");

    const transactionParameters = {
      to: EMETH_PROXY_CONTRACT_ADDRESS, // Required except during contract publications.
      from: ethereum.selectedAddress, // must match user's active address.
      value: amountValue.toString(16),
      data,
    };

    await ethereum.request({ method: "eth_requestAccounts" });

    // txHash is a hex string
    // As with any RPC call, it may throw an error
    const txHash = await ethereum.request({
      method: "eth_sendTransaction",
      params: [transactionParameters],
    });
    console.log(txHash);
    return txHash;
  } catch (error) {
    const message = (error as any).message || (error as any).reason;
    console.log("message", message);
    return `ERROR: ${message}`;
  }
};
